let locale = 'en';

function createName(a) {
  const keys = ['companyName', 'firstName', 'lastName', 'address', 'address2', 'city'];

  return keys.reduce((acc, key) => {
    if (a[key]) {
      acc.push(a[key]);
    }

    return acc;
  }, []).join(' ');
}

function sort(a, b) {
  const aName = createName(a);
  const bName = createName(b);

  switch (true) {
    default:
      return 0;

    case a.isDefault && Array.isArray(a.isDefault) && a.isDefault.indexOf('billingAddress') > -1:
      return -1;

    case b.isDefault && Array.isArray(b.isDefault) && b.isDefault.indexOf('billingAddress') > -1:
      return 1;

    case a.isDefault && Array.isArray(a.isDefault) && a.isDefault.indexOf('shippingAddress') > -1:
      return -1;

    case b.isDefault && Array.isArray(b.isDefault) && b.isDefault.indexOf('shippingAddress') > -1:
      return 1;

    case aName && bName && aName.localeCompare:
      return aName.localeCompare(bName, locale, { sensitivity: 'base' });

    case aName && bName && aName !== bName:
      return (aName < bName) ? -1 : 1;
  }
}

function sort_addresses(items) {
  if (
    this.context
    && this.context.config
    && this.context.config.language
  ) {
    locale = this.context.config.language;
  }

  items.sort(sort);

  return items;
}

module.exports = sort_addresses;



// WEBPACK FOOTER //
// ./src/libs/twig/sort_addresses/index.js